




























































































// TODO: Refactor p-select to be more accessible
// Use this guide if it's helpful:
// https://css-tricks.com/striking-a-balance-between-native-and-custom-select-elements/
import Vue, { PropType } from 'vue';
import PTextField from '../p-text-field/p-text-field.vue';
import interactable from '../../mixins/interactable/interactable';
import colorable from '../../mixins/colorable/colorable';
import mixins from '../../mixins';
import sizeable from '../../mixins/sizeable/sizeable';
import validatable from '../../mixins/validatable/validatable';
import _ from '../../utils';

export interface pSelectItem {
  [prop: string | number]: any,
  caption?: string,
  detail?: string,
  sort?: number,
  disabled?: boolean,
}

export default mixins(interactable, colorable, sizeable, validatable).extend({
  mixins: [interactable, colorable, sizeable, validatable],
  props: {
    items: { default: () => [], type: Array as PropType<pSelectItem[]> },
    itemDisplay: { default: 'caption', type: String },
    itemDetail: { default: 'detail', type: String },
    itemValue: { default: 'id', type: String },
    itemDisabled: { default: 'disabled', type: String },
    canSearch: { default: false, type: Boolean },
    performLocalSearch: { default: true, type: Boolean },
    search: { default: undefined, type: String },
    dense: { default: true, type: Boolean },
    ...((new PTextField()).$options.props),
    value: { default: undefined, type: [Number, String, Boolean, Object, Array] },
  },
  data: () => ({
    searchMode: false,
    selectedItem: undefined as Record<string, any> | undefined,
    selectedItemIndex: undefined as number | undefined,
    itemsVisible: false,
    internalSearch: undefined as string | undefined,
    lastKeyPresses: [] as string[],
  }),
  computed: {

    computedContextIcon() {
      if (this.searchMode) {
        return 'search';
      }
      return (this as any).contextIcon;
    },
    computedActionIcon() {
      if (this.readonly || this.disabled) {
        return 'expand_more';
      }
      if ((this as any).actionIcon !== undefined) {
        return (this as any).actionIcon;
      }
      return this.itemsVisible ? 'expand_less' : 'expand_more';
    },
    computedValue() {
      if (this.searchMode) {
        return this.internalSearch;
      }
      return (this as any).getItemDisplay(this.selectedItem);
    },
    computedCanSearch() {
      const canShowSearch = (this as any).canSearch;
      return canShowSearch && !this.readonly && !this.disabled;
    },
    computedFilteredItems() {
      if (!this.search || !this.performLocalSearch) {
        return this.items;
      }
      return this.items.filter((item: any) => {
        const match = Object.keys(item).find((key) => {
          const itemDisplay = item[key];
          if (typeof itemDisplay === 'string') {
            const searchPieces = this.search.split(' ') as string[];
            const pieceMatch = searchPieces.find((piece) => {
              return itemDisplay.toLowerCase().includes(piece.toLowerCase());
            });
            return !!pieceMatch;
          }
          return itemDisplay === this.search;
        });
        return !!match;
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.setSelectedItem(this.value);
      },
    },
    items: {
      immediate: true,
      handler() {
        this.setSelectedItem(this.value);
      },
    },
  },
  methods: {
    onTabDown() {
      this.$nextTick(() => {
        this.setItemsVisible(false);
      });
    },
    onSpaceDown(event: KeyboardEvent) {
      if (this.searchMode) {
        return;
      }
      event.preventDefault();
      this.toggleItemsVisible();
    },
    onEnterDown(event: KeyboardEvent) {
      event.preventDefault();
      this.toggleItemsVisible();
    },
    onKeyDown(event: KeyboardEvent) {
      if (this.canSearch) {
        return;
      }
      this.$debounce(() => {
        this.lastKeyPresses = [];
      }, 600, this.onKeyDown)();

      const { key } = event;

      // Native select cycles through items if key that was typed is same as last
      if (this.lastKeyPresses.length === 1 && key === this.lastKeyPresses[0]) {
        const allMatches = this.items
          .map((item, index) => ({ index, item }))
          .filter((item) => {
            const display = item.item?.[this.itemDisplay];
            const [displayFirstChar] = display;
            const isMatch = displayFirstChar?.toLowerCase() === key?.toLowerCase();
            const isDisabled = item.item?.[this.itemDisabled];
            return isMatch && !isDisabled;
          });
        let match = allMatches.find((item) => item.index > (this.selectedItemIndex ?? 0));
        if (!match) {
          [match] = allMatches;
        }
        if (match) {
          this.selectOption(match.item);
        }
      } else {
        this.lastKeyPresses.push(key);

        const itemMatch = this.items.find((item) => {
          const itemDisplay = item?.[this.itemDisplay]?.toLowerCase()?.replace(/\s/g, '');
          const isMatch = itemDisplay?.startsWith(this.lastKeyPresses.join(''));
          const isDisabled = item?.[this.itemDisabled];
          return isMatch && !isDisabled;
        });
        if (itemMatch) {
          this.selectOption(itemMatch);
        }
      }
    },
    getInputEl() {
      const textField = this.$refs['text-field'] as Vue;
      if (!textField) {
        return undefined;
      }
      return textField.$el.getElementsByClassName('p-text-field-input-wrapper')[0];
    },
    selectNextOption() {
      const startIndex = Math.min((this.selectedItemIndex ?? -1) + 1, this.items.length - 1);
      for (let i = startIndex; i < this.items.length; i += 1) {
        const item = this.items[i];
        if (item?.[this.itemDisabled]) {
          continue;
        } else {
          this.selectOption(this.items[i]);
          break;
        }
      }
    },
    selectPreviousOption() {
      const startIndex = Math.max((this.selectedItemIndex ?? 1) - 1, 0);
      for (let i = startIndex; i >= 0; i -= 1) {
        const item = this.items[i];
        if (item?.[this.itemDisabled]) {
          continue;
        } else {
          this.selectOption(this.items[i]);
          break;
        }
      }
    },
    onExpanderClick() {
      this.toggleItemsVisible();
    },
    setItemsVisible(expanded: boolean) {
      if (this.readonly || this.disabled) {
        return;
      }
      this.itemsVisible = expanded;
      if (this.itemsVisible && this.value === undefined) {
        this.selectOption(this.items[0]);
      }
    },
    toggleItemsVisible() {
      this.setItemsVisible(!this.itemsVisible);
    },
    onClearClicked() {
      this.selectedItem = undefined;
      this.onInput(undefined);
      this.$emit('input', undefined);
      this.$emit('display', this.getItemDisplay(undefined));
    },
    clickOption(item: any) {
      this.selectOption(item);
      this.itemsVisible = false;
    },
    selectOption(item: any) {
      if (this.readonly || this.disabled) {
        return;
      }
      if (this.getItemDisabled(item)) {
        return;
      }
      this.setSelectedItem(item);
      this.emitValue(this.selectedItem);
    },
    /** @param item can be either a value or an item object */
    setSelectedItem(item: any) {
      const value = _.isObject(item) ? item[this.itemValue] : item;
      if (value === null || value === undefined) {
        this.selectedItem = undefined;
        return;
      }
      const found = this.items.find((i) => i[this.itemValue] === value);
      if (found) {
        this.selectedItemIndex = this.items.indexOf(found);
        this.selectedItem = found;
      }
    },
    emitValue(entry: any) {
      const value = this.getItemValue(entry);
      const display = this.getItemDisplay(entry);
      this.$emit('input', value);
      this.$emit('display', display);
    },
    getItemDisabled(item: Record<string, any>) {
      if (item === undefined) {
        return true;
      }
      if (_.isObject(item)) {
        return item[this.itemDisabled] ?? false;
      }
      return false;
    },
    getItemDisplay(item?: Record<string, any>) {
      if (item === undefined) {
        return '';
      }
      if (_.isObject(item)) {
        return item[this.itemDisplay];
      }
      return item;
    },
    getItemDetail(item: Record<string, any>) {
      if (item === undefined) {
        return '';
      }
      if (_.isObject(item)) {
        return item[this.itemDetail];
      }
      return item;
    },
    getItemValue(item: Record<string, any>) {
      if (_.isObject(item)) {
        return item[this.itemValue];
      }
      return item;
    },
    onDisplayFocus() {
      if (this.computedCanSearch) {
        this.searchMode = true;
      }
    },
    onInput(value: any) {
      if (this.searchMode) {
        this.onSearchInput(value);
      }
    },
    onSearchFieldBlur() {
      this.searchMode = false;
      this.updateSearch(undefined);
    },
    updateSearch(value?: string) {
      this.internalSearch = value;
      this.$emit('update:search', value);
    },
    onSearchInput(value: any) {
      this.itemsVisible = true;
      this.updateSearch(value);
      // TODO: Put this into a config, or inject somehow?
      this.$debounce(() => {
        this.$emit('search', value);
      }, 250, this)();
    },
  },
});
